import styled, { css } from "styled-components"
import { PrimaryButton } from "@humanpredictiveintelligence/myqvt-library"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 2px;
`

export const Header = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 220px minmax(400px, 1fr) 180px 300px;
    align-items: center;
    padding: 0 28px 16px 28px;
    color: ${theme.colors.grey};
    font-size: 13px;
  `}
`

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  height: 100%;
  padding-bottom: 16px;
`

export const Row = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.borderLight};
    border-radius: 6px;
    box-shadow: ${theme.shadows.bottom};
    cursor: pointer;
  `}
`

export const RowContent = styled.div`
  display: grid;
  grid-template-columns: 220px minmax(400px, 1fr) 180px 300px;
  align-items: center;
  min-height: 42px;
  padding: 0 28px;
  font-size: 13px;
`

export const StatusCell = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.black};
  `}
`

export const QuestionCell = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`

export const ChoicesCountCell = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.black};
  `}
`

export const ActionsCell = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.2rem;
`

export const ExpandedContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 12px 28px 18px 208px;
    border-top: 1px solid ${theme.colors.borderLight};
    margin-left: 40px;
  `}
`

export const ChoicesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Choice = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ChoiceIndex = styled.span`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${theme.colors.primary};
    color: ${theme.colors.white};
    font-size: 12px;
    font-weight: 600;
  `}
`

export const ChoiceName = styled.span`
  ${({ theme }) => css`
    font-size: 13px;
    color: ${theme.colors.black};
  `}
`

export const ActionButton = styled(PrimaryButton)`
  margin: 0.2rem 0;
  border-radius: 0.2rem;  
`

export const Pagination = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 8px;
`

export const EmptyQuestionsMessage = styled.div`
  height: 100%;
  
  display: flex;
  justify-content: center;
  align-items: center;
`
